document.addEventListener('DOMContentLoaded', () => {
  const productGrid = document.querySelector('#product-grid');
  const trigger = document.querySelector('#load-more-trigger');
  const loadingIndicator = document.querySelector('#loading-indicator');
  
  if (!productGrid || !trigger) return;
  
  const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && trigger.dataset.nextUrl) {
      const nextUrl = trigger.dataset.nextUrl;
      
      // Show loading indicator
      if (loadingIndicator) {
        loadingIndicator.style.display = 'block';
      }
      
      // Store the URL but don't remove it yet (in case the request fails)
      const currentUrl = trigger.dataset.nextUrl;
      
      fetch(nextUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newProducts = doc.querySelectorAll('#product-grid > *');
          
          newProducts.forEach(item => productGrid.appendChild(item));
          
          const newTrigger = doc.querySelector('#load-more-trigger');
          if (newTrigger && newTrigger.dataset.nextUrl) {
            trigger.setAttribute('data-next-url', newTrigger.dataset.nextUrl);
          } else {
            trigger.remove(); // No more pages
          }
        })
        .catch(error => {
          console.error('Error loading more products:', error);
          // If there's an error, keep the trigger active so user can try again
          trigger.dataset.nextUrl = currentUrl;
        })
        .finally(() => {
          // Hide loading indicator
          if (loadingIndicator) {
            loadingIndicator.style.display = 'none';
          }
        });
    }
  }, { rootMargin: '300px' });
  
  observer.observe(trigger);
});